import {
  useFormatFieldValue,
  type FieldFormat,
} from "@coworker/apprestructured/src/task-management/hooks/useFormatFieldValue";

/**
 * Returns a formatter function for arrays of objects.
 * Uses useFormatFieldValue internally for consistent formatting logic.
 * Returns a comma-separated string of formatted values.
 */
export function useFormatArrayFieldValue() {
  const formatFieldValue = useFormatFieldValue();

  return (values: string[], format?: FieldFormat): string => {
    return values.map((v) => formatFieldValue(v, format)).join(", ");
  };
}
